<template>
  <div class="footer-contact-column caption">
    <div class="column-header">
      <div class="header-icon">
        <img src="../assets/icons/arrow-right-black-extended.svg" alt="">
      </div>
      <div class="overline">{{$t('footer.contact')}}</div>
    </div>
    <div class="info-row">
      <div class="icon-container">
        <img src="../assets/icons/location-icon.svg" alt="">
      </div>
      <a
        href="https://www.google.com/maps/place/Churerstrasse+54,+8808+Pf%C3%A4ffikon,+Switzerland/@47.2012196,8.7782759,17z/data=!3m1!4b1!4m6!3m5!1s0x479ab14d5cbde19f:0x9fe764032bac78e7!8m2!3d47.2012196!4d8.7804646!16s%2Fg%2F11c5k_0qw3"
        target="_blank">Churerstrasse 54<br/>
        CH-8808 Pfäffikon SZ</a>
    </div>
    <div class="info-row">
      <div class="icon-container">
        <img src="../assets/icons/phone-icon-black.svg" alt="">
      </div>
      <a href="tel:+41 (0)58 521 19 00">+41 (0)58 521 19 00</a>
    </div>
    <div class="info-row">
      <div class="icon-container">
        <img src="../assets/icons/world-icon.svg" alt="">
      </div>
      <a href="http://www.seu.ch" target="_blank">www.seu.ch</a>
    </div>

    <div class="info-row">
      <div class="icon-container">
        <img src="../assets/icons/mail-icon.svg" alt="">
      </div>
      <a href="mailto: info@seu.ch">info@seu.ch</a>
    </div>


  </div>
</template>

<script>
export default {
  name: "FooterContactColumn",

}
</script>

<style lang="scss">
@import "FooterContactColumn.scss";
</style>
